module.exports = __webpack_public_path__ + "img/short-hand-logo-white.c602a56b.png";